<template lang="pug">
menu-item(:label=`$t('hips_info')`, v-model="module.showWindow", keybind="H")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { HipsModule } from "@/modules/HipsModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: HipsModule
}
</script>

<i18n>
en:
  hips_info: HiPS Info
ja:
  hips_info: HiPS情報

</i18n>